module.exports = __webpack_public_path__ + "static/media/In_Depth_Hero_Mobile_1.c36476d3.png";